import React from "react";
import styled from "styled-components";
import { SkeletonBlock } from "../../UI";
import { theme } from "../../../utils/theme";

export const NewLeadFormV2Skeleton: React.FC = () => {
  return (
    <PopupContainerDiv>
      {/* Header skeleton */}
      <Header>
        <SkeletonBlock width={120} height={20} borderRadius={4} />
        <SkeletonBlock width={16} height={16} borderRadius={4} delayNumber={1} />
      </Header>

      <FormContent>
        <FormGrid>
          {/* First Name */}
          <InputFieldWrapper>
            <SkeletonBlock width={120} height={16} borderRadius={4} delayNumber={2} />
            <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={3} />
          </InputFieldWrapper>

          {/* Last Name */}
          <InputFieldWrapper>
            <SkeletonBlock width={130} height={16} borderRadius={4} delayNumber={16} />
            <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={17} />
          </InputFieldWrapper>

          {/* Business Name */}
          <InputFieldWrapper>
            <SkeletonBlock width={100} height={16} borderRadius={4} delayNumber={4} />
            <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={5} />
          </InputFieldWrapper>

          {/* Channel */}
          <SkeletonBlock width={60} height={16} borderRadius={4} delayNumber={18} />
          <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={19} />

          {/* Email */}
          <InputFieldWrapper>
            <SkeletonBlock width={90} height={16} borderRadius={4} delayNumber={6} />
            <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={7} />
          </InputFieldWrapper>

          {/* Sub-Industry */}
          <SkeletonBlock width={90} height={16} borderRadius={4} delayNumber={20} />
          <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={21} />

          {/* Lead Source */}
          <InputFieldWrapper>
            <SkeletonBlock width={80} height={16} borderRadius={4} delayNumber={8} />
            <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={9} />
          </InputFieldWrapper>

          {/* City */}
          <InputFieldWrapper>
            <SkeletonBlock width={40} height={16} borderRadius={4} delayNumber={22} />
            <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={23} />
          </InputFieldWrapper>

          {/* Industry */}
          <InputFieldWrapper>
            <SkeletonBlock width={70} height={16} borderRadius={4} delayNumber={10} />
            <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={11} />
          </InputFieldWrapper>

          {/* State */}
          <InputFieldWrapper>
            <SkeletonBlock width={100} height={16} borderRadius={4} delayNumber={24} />
            <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={25} />
          </InputFieldWrapper>

          {/* Country */}
          <InputFieldWrapper>
            <SkeletonBlock width={60} height={16} borderRadius={4} delayNumber={12} />
            <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={13} />
          </InputFieldWrapper>

          {/* Brand (conditional) */}
          <InputFieldWrapper>
            <SkeletonBlock width={50} height={16} borderRadius={4} delayNumber={14} />
            <SkeletonBlock width={210} height={40} borderRadius={4} delayNumber={15} />
          </InputFieldWrapper>
        </FormGrid>

        {/* Button skeleton */}
        <ButtonContainer>
          <SkeletonBlock width={120} height={40} borderRadius={4} delayNumber={26} />
        </ButtonContainer>
      </FormContent>
    </PopupContainerDiv>
  );
};

const PopupContainerDiv = styled.div`
  display: flex;
  position: fixed;
  top: 12px;
  left: 12px;
  flex-direction: column;
  background: ${theme.WHITE_COLOR};
  border-radius: 8px;
  border: 1px solid ${theme.NEUTRAL200};
  width: fit-content;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  z-index: 9000;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: ${theme.PRIMARY900};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 8px;
  max-height: calc(90vh - 40px);
  overflow-y: auto;
  overflow-x: hidden;

  /* Show scrollbar when needed */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${theme.NEUTRAL100};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.NEUTRAL300};
    border-radius: 4px;

    &:hover {
      background: ${theme.NEUTRAL400};
    }
  }
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 8px;
  align-items: start;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 0px;
`;

const InputFieldWrapper = styled.div`
  margin-bottom: 2px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
